export default __webpack_public_path__ + "static/media/integrity-temp-grip-filmstaerke.ea1d84b0.svg";